define(['jquery', 'jquery.transit', 'modernizr', 'container', 'jump'], function($, transit, modernizr, container, jumpFactory) {

    var lightbox = function(id) {

        var publicVars = {
        };

        var privateVars = {
            name: 'lightbox(' + id + ')',
            open: 0, /*if lightbox is closed or opened */
            stateClosing: false,
            stateOpening: false,
            disabledClickClose: false
        };

        var jump = jumpFactory.create();


        var privateMethods = {
            prepareObj: function(options) {

                publicVars = container.performCopy(publicVars, options);

                privateMethods.preloadImages();

                privateMethods.bind();

                privateMethods.startup();


            },
            /*
             * preload images
             */
            preloadImages: function() {

            },
            startup: function() {

            },
            bind: function() {

                container.msg(privateVars.name + ' - module started');

                $(publicVars.cssId.lightboxCall).click(function () {
                    privateMethods.showLayer();
                });

                $(publicVars.cssId.lightboxClose).click(function() {
                    privateMethods.closeLayer();
                });

                $(document).mouseup(function(e)
                {
                    var container = $(publicVars.cssId.lightbox);

                    if (!container.is(e.target) // if the target of the click isn't the container...
                            && container.has(e.target).length === 0 && !privateVars.disabledClickClose) // ... nor a descendant of the container
                    {
                        privateMethods.closeLayer();
                    }
                });

            },
            showLayer: function(callback) {
                if (privateVars.open === 0 && !privateVars.stateClosing && !privateVars.stateOpening) {

                    privateVars.open = 1;

                    privateVars.stateOpening = true;

                    $(publicVars.cssId.lightboxHidePage).addClass(publicVars.cssId.lightboxHideInactiveCls.substr(1));

                    if (publicVars.center == 1) {
                        $(publicVars.cssId.lightbox).css({opacity: 0, display: 'block'});
                        jump.centerTo($(publicVars.cssId.lightbox));
                    } else if (publicVars.cssId.lightboxJumpId !== undefined) {

                        var state = 0;

                        var topPos = $(publicVars.cssId.lightboxJumpId).offset();


                        $('html, body').animate({scrollTop: (topPos.top - 20) + 'px'}, 400, function() {

                            if (state == 0)
                            {
                                state = 1;
                            }

                        });

                    }

                    $(publicVars.cssId.lightbox).css({transform: 'scale(0)', opacity: 0, display: 'block'});

                    $(publicVars.cssId.lightbox).transit({transform: 'scale(1)', opacity: 1}, 500, function() {

                        container.msg(privateVars.name + ' - opened');

                        privateVars.stateOpening = false;

                        if (typeof callback === 'function') {

                            callback();
                        }
                    });
                }
            },
            closeLayer: function(callback) {
                if (privateVars.open === 1 && !privateVars.stateClosing && !privateVars.stateOpening) {

                    privateVars.stateClosing = true;

                    $(publicVars.cssId.lightboxHidePage).removeClass(publicVars.cssId.lightboxHideInactiveCls.substr(1));

                    $(publicVars.cssId.lightbox).transit({scale: 0, opacity: 0}, 300, function() {
                        $(publicVars.cssId.lightbox).removeAttr('style');
                        $(publicVars.cssId.lightbox).css({display: 'none'});



                        privateVars.open = 0;
                        privateVars.stateClosing = false;
                        container.msg(privateVars.name + ' - closed');

                        if (typeof privateVars.closeCallback === 'function') {
                            privateVars.closeCallback();
                        }

                        if (typeof callback === 'function') {
                            callback();
                        }
                    });
                }
            },
            getStatus: function() {
                if (privateVars.open == 1) {
                    return 1;
                } else {
                    return 0;
                }
            },
            setCloseCallback: function(closeCallback) {
                privateVars.closeCallback = closeCallback;
            }



        };


        var publicObj = {
            init: function(options) {
                privateMethods.prepareObj(options);
            },
            close: function(callback) {
                privateMethods.closeLayer(callback);
            },
            showLayer: function(callback) {
                privateMethods.showLayer(callback);
            },
            getStatus: function() {
                return privateMethods.getStatus();
            },

            setCloseCallback: function(closeCallback) {
                privateMethods.setCloseCallback(closeCallback);
            },

        }


        return publicObj;
    };

    var factory = {
        objId: 0,
        /**
         * Get new preloader object
         * 
         * @returns preloader
         */
        create: function() {
            factory.objId++;

            var obj = lightbox(factory.objId);

            return obj;
        }
    };

    return {
        create: factory.create
    }

});

/*
 ---
 var lightbox = lightboxFactory.create();
 ------
 <div class="lightbox-outer" id="lightbox">
 <div class="lightbox">
 
 <div class="site-ajax-loader"><img src="{$baseurl}/assets/img/layout/ajax-loader.gif" /></div> 
 
 <div class="lightbox-inner {*lightbox-inner-loading*}">
 
 <div class="lightbox-inner-loading-guard"></div>
 
 <div class="lightbox-close" id="lightbox-close">x</div>
 
 
 </div>
 </div>
 </div>
 ----
 lightboxSetup: {
 cssId: {
 'lightbox': '#lightbox',
 'lightboxClose': '#lightbox-close',
 'lightboxCall': '#lightbox-call'
 }
 }
 ----
 */